/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue , Watch} from 'vue-property-decorator'
import { setCustomerConversionFollow, getCustomerConversionFollowListByCustomerConversionId ,setCustomerConversionFollowById } from '@/api/customer'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import DUploadFile from '@/components/uploadFile/index.vue'

import {Loading} from "element-ui";
import axios from "axios";
import {makeUploadSignature} from '@/utils/uploadMd5'
@Component({
    components: { DUploadFile }
})
export default class Fllow extends Vue {
    fileList: { name: string; url: string }[] = []
    tableData = []
    page = 1
    limit = 20
    total = 0
    id: number
    name = ''
    deadline: Date = null // 截止时间
    // time = null
    customerConversionId: number

    datePickerOptions = {
        disabledDate: (v: Date) => (true),
    }
    // timePickerOptions = { start: '00:00', step: '01:00', end: "23:59" }
    startDate: Date = null
    endDate: Date = null // 计算得出最后的结束时间为什么时候
    flag = false // 是否修改过时间没如果修改过就给后台传值
    disBtn = false
    formModel = {
        selectValue: '',
        textValue: '',
        selectNameList: [],
        isHaveRegisterInfo : '',
        isHaveProject : '',
        isSolveSelect : '',
        customerConversionFollowDataList : [],
    }
    formRules = {
        selectValue: [{required: true, message: '请选择购买意向', trigger: 'change'}],
        textValue: [{required: true, message: '请输入跟进内容', trigger: 'blur'}], // 改成必填
        selectNameList: [{required: true,message: '请输入卡点原因',trigger: ['blur', 'change']}],
        isHaveRegisterInfo : [{required: true, message: '请选择是否提交报名信息', trigger: 'change'}],
        isHaveProject : [{required: true, message: '请选择是否项目', trigger: 'change'}],
        isSolveSelect : [{required: true, message: '请选择是否解决卡点', trigger: 'change'}],
    }
    axios = null
    reasonList = [
        '升学意向', '支付能力', '时间安排', '家庭支持', '替代品类', '竞品干扰', '产品功能', '差评干扰', '产品匹配', '无故失联','学员意愿','专业选择','其他'
    ]
    reasonProp = ''
    intentionalityList =  [
        {label:'A',value:'A',interpretation:'（7天内签约）'},
        {label:'B',value:'B',interpretation:'（15天内签约）'},
        {label:'C',value:'C',interpretation:'（30天内签约）'},
        {label:'D',value:'D',interpretation:'（90天内签约）'},
        {label:'E',value:'E',interpretation:'（长期跟进）'},
        {label:'F',value:'F',interpretation:'（流失并调入公海）'},
        // {label:'已签约',value:'已签约',interpretation:''},
    ]
    loading = false
    formLoading = false
    menuBtn = menuBtn
    isDisabled = false
    previewVisible = false
    previewPath = ''
    previewName = ''
    haveFinanceContract = false
    uploadData = {
        bucket: 'crm',
        signature: ''
    }



    created() {
        this.$nextTick(() => {
            (this.$refs['el-table'] as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
                const height = res.target;
                const clientHeight = height.clientHeight;
                const scrollTop = height.scrollTop;
                const scrollHeight = height.scrollHeight;
                if (clientHeight + scrollTop >= scrollHeight) {
                    if (this.tableData.length >= this.total) {
                        return
                    }
                    this.limit += 20
                }
            }, true);
        })

        // 拿到当前转化客户的id
        this.customerConversionId = Number(this.$route.query.id)
        this.name = this.$route.query.name as string
        this.haveFinanceContract = this.$route.query.haveFinanceContract === 'true' as any
        this.getTableData()
        this.createAxios();
        if(this.haveFinanceContract) {
            this.formModel.selectValue = 'A'
            this.isDisabled = true
            this.intentionalityChange('A')
        }
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }
    get isHaveRegisterInfoAndIsHaveProjectAndIsSolveSelect() {
        const {isHaveRegisterInfo, isHaveProject, isSolveSelect} = this.formModel
        return {
            isHaveRegisterInfo,
            isHaveProject,
            isSolveSelect
        }
    }

    @Watch('isHaveRegisterInfoAndIsHaveProjectAndIsSolveSelect', {
        immediate: true,
        deep: true
    })
    handleVal(newVal, oldVal) {
        //     如果都是"是"
        if ((newVal.isHaveRegisterInfo === '是' && newVal.isHaveProject === '是' && newVal.isSolveSelect === '是') || this.haveFinanceContract) {
            this.formModel.selectValue = 'A'
            this.isDisabled = true
            this.intentionalityChange('A')
        } else {
            this.formModel.selectValue = ''
            this.isDisabled = false
            //     禁止选中A
            this.intentionalityList.forEach((item: any) => {
                if (item.value === 'A') {
                    item.disabled = true
                } else {
                    item.disabled = false
                }
            })
        }
    }

    mounted() {
        this.datePickerOptions.disabledDate = (v: Date) => {
            const emun = {'A': 3, 'B': 5, 'C': 7, 'D': 15, 'E': 30}
            const nowtime = v.getTime()
            const starttime = new Date().setHours(0, 0, 0, 0) + 1
            const endtime = (new Date().getTime() + 1000 * 60 * 60 * 24 * emun[this.formModel.selectValue])
            this.startDate = new Date()
            if(!this.formModel.selectValue) {
                return true
            }
           if(this.formModel.selectValue === '已签约'||this.formModel.selectValue === 'F') {
                return !(v.setHours(0,0,0,0) >= starttime)
            }
            this.endDate = new Date(endtime)
            return !(nowtime >= starttime && nowtime <= endtime)
        }
    }

    // methods
    async confirm() {
        if (this.formModel.selectValue === '' ) {
            this.$message.error(`请将${this.formModel.selectValue === '' ? '客户等级，' : ''}填写完整`)
            return
        }
        if(!(this.formModel.selectValue =='A'||this.formModel.selectValue=='已签约') && this.formModel.selectNameList.length==0){
            this.$message.error(`请将卡点原因填写完整`)
            return
        }
        if(!this.deadline) {
            this.$message.error(`请选择下次回访时间`)
            return
        }
        let isConfirmFlag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                isConfirmFlag = false
            }
        })
        const obj = {
            customerConversionId: this.customerConversionId,
            intentionality: this.formModel.selectValue,
            content: this.formModel.textValue,
            // lastFollowAt: formatDate('yyyy-MM-dd', new Date(this.deadline)) + ' ' + (this.time ? this.time : '00:00'),
            lastFollowAt: formatDate('yyyy-MM-dd', new Date(this.deadline)),
            selectNameList: this.formModel.selectNameList,
            isHaveRegisterInfo : this.formModel.isHaveRegisterInfo,
            isHaveProject : this.formModel.isHaveProject,
            isSolveSelect : this.formModel.isSolveSelect,
            customerConversionFollowDataList:this.formModel.customerConversionFollowDataList,
        }
        // if (!this.flag || !this.deadline) {
        //     delete obj.lastFollowAt
        // } // 2023-9-22更改 ，不管回访截止时间变不变都传值
        if (!this.deadline) {
            delete obj.lastFollowAt
        }
        if (this.formModel.selectNameList.length<1) {
            delete obj.selectNameList
        }
        if (this.formModel.customerConversionFollowDataList.length == 0) {
            delete obj.customerConversionFollowDataList
        }
        if (isConfirmFlag) {
            this.disBtn = true
            this.formLoading = true
            await setCustomerConversionFollow(obj).then(()=>{
            this.$nextTick(() => {
                this.getTableData()
                this.formModel.selectValue = ''
                this.formModel.textValue = ''
                this.deadline = null
                // this.time = ''
                this.$message.success('新增跟进记录成功')
                this.flag = false
                this.disBtn = false
                this.formModel.selectNameList = []
                this.formModel.isHaveRegisterInfo = ''
                this.formModel.isHaveProject = ''
                this.formModel.isSolveSelect = ''
                this.isDisabled = false
                this.formLoading = false
            })
            }).catch(err=>{
                this.formLoading = false
            })
        }
    }

    async getTableData() {
        if (this.menuBtn(68)) return
        this.loading = true
        await getCustomerConversionFollowListByCustomerConversionId({
            customerConversionId: this.customerConversionId,
            limit: this.limit,
            page: this.page
        }).then((data: any) => {
            this.total = data.allNum
            this.tableData = data.customerConversionFollowList
            this.tableData = this.tableData.map((item: any) => ({...item, isEdit: false}))
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }

    async confirmEdit(row: any) {
        if (!row.content) {
            this.$message.error(`请将跟进内容填写完整`)
            return
        }
        const obj = {
            id: row.id,
            content: row.content,
            customerConversionFollowDataList: [...row.customerConversionFollowDataList, ...this.fileList]
        }
        if ([...row.customerConversionFollowDataList, ...this.fileList].length == 0) {
            delete obj.customerConversionFollowDataList
        }
        await setCustomerConversionFollowById(obj)
        this.$message.success('保存成功')
        row.isEdit = false
        this.fileList = []
    }

    clickEditbtn(row: any) {
        const bol = this.tableData.some(item => item.isEdit)
        if (bol) {
            this.$message({
                type: 'error',
                message: '请先将其它处于编辑状态的跟进记录保存后在开启新的编辑',
                duration: 3000
            })
            return
        }
        this.id = row.id
        row.isEdit = true
    }

    handleUploadSuccess(res, file, fileList) {
        if (res.error.returnCode !== 0) {
            this.$message.error(`上传失败，${res.error.returnMessage}`)
            return
        }
        this.$message.success('上传成功')
        this.fileList.push({ name: file.name, url: res.data.ossUrl })
    }
    handleUploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file, fileList) {
        // this.tableData.forEach(item => {
        //     if(item.id === this.id) {
        //         item.customerConversionFollowDataList = fileList
        //     }
        // })
        this.formModel.customerConversionFollowDataList = fileList
    }

    deadlineChange() {
        // this.time = ''
        if(new Date(this.deadline).setHours(0,0,0,0) === new Date(this.startDate).setHours(0,0,0,0)) {
            // this.timePickerOptions.start = `${this.startDate.getHours()}:${'00'}`
            // this.timePickerOptions.end = '23:59'
        } else if(new Date(this.deadline).setHours(0,0,0,0) === new Date(this.endDate).setHours(0,0,0,0)) {
            // this.timePickerOptions.start = '00:00'
            // this.timePickerOptions.end = `${this.endDate.getHours()}:${'00'}`
            // this.timePickerOptions.end = `${this.endDate.getHours()}:${this.endDate.getMinutes()}`
        } else {
            // this.timePickerOptions.start = '00:00'
            // this.timePickerOptions.end = '23:59'
        }
    }

    intentionalityChange(val: string) {
        this.deadline = new Date(new Date());
        if (val === 'B' || val === 'C' || val === 'D' || val === 'E' || val === 'F') {
            this.reasonProp = `selectNameList`
        } else {
            this.reasonProp = ''
        }

        if (val === 'A') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 3));
        this.endDate = this.deadline
        if (val === 'B') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 5));
        this.endDate = this.deadline
        if (val === 'C') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 7));
        this.endDate = this.deadline
        if (val === 'D') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 15));
        this.endDate = this.deadline
        if (val === 'E') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 30));
        this.endDate = this.deadline
        if (val === 'F') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 30));
        this.endDate = this.deadline
        if (val === '已签约') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24));
        this.endDate = this.deadline
        // this.$nextTick(() => {
        //     this.time = this.endDate.getHours() + ':' + '00'
        // })
        this.deadlineChange()

    }

    createAxios() {
        const origin = location.hostname; //当前访问域名
        let requestBase = "";
        if (process.env.NODE_ENV === "development") {
            requestBase = process.env.VUE_APP_BASE_FILE_API_PROXY;
        } else {
            if (origin.indexOf("-testserver") > -1) {
                requestBase = process.env.VUE_APP_DEV_FILE_API;
            } else {
                requestBase = process.env.VUE_APP_MASTER_FILE_API;
            }
        }
        const config = {
            baseURL: requestBase,
            timeout: 30 * 1000, // Timeout
        };
        this.axios = axios.create(config);
    }

    async uploadFile(row: any, e: any) {
        const loading = Loading.service({ text: '正在上传文件' })
        const file = e.target.files[0]
        const formdata = new FormData()
        formdata.append('file', file, file.name)
        formdata.append('bucket', 'crm')
        const signature = makeUploadSignature('crm', file.name)
        formdata.append('signature',signature)
        this.axios.post(
                "/upload/upload",
                   formdata
        ).then(res => {
            this.$message.success('文件上传成功')
            const data: any = res.data.data
            row.customerConversionFollowDataList.push({
                name: data.name,
                url: data.ossUrl
            })
            this.$nextTick(() => {
                loading.close()
            })
        }).catch(error=>{
            this.$nextTick(() => {
                loading.close()
            })
       })
    }

    delFile(row: any, index: number) {
        row.splice(index, 1)
    }


    uploadSuccess (res: any, file: any, fileList: any) {
        if (res.error.returnCode !== 0) {
            this.$message.error(`上传失败，${res.error.returnMessage}`)
            return
        }
        // this.$message.success('上传成功')
        // this.formModel.customerConversionFollowDataList.push({ name: file.name, url: res.data.ossUrl })
        if (fileList.every(item => item.status == 'success')) {
            this.formModel.customerConversionFollowDataList = fileList.map(item => {
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            });
            this.$message.success('上传成功');
            // 手动触发 Vue 更新
            this.$forceUpdate();
        }
    }
    uploadError () {
        this.$message.error('上传失败')
    }

    handlePreview(file) {
        if (file.response) {
            this.previewPath = file.response.data.url
        } else {
            this.previewPath = file.url
        }
        this.previewName = file.name
        this.previewVisible = true

    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    beforeUpload(file) {
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }
}
